// src/components/UserCard.js

import React, { useState } from 'react';
import { logoutUserByAdmin, deleteUser } from '../api/quontxApi';

const UserCard = ({ user, onUserDeleted }) => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [logoutError, setLogoutError] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState('');

  const handleForceLogout = async () => {
    if (!window.confirm(`Are you sure you want to force logout user: ${user.username}?`)) return;
    setIsLoggingOut(true);
    setLogoutError('');
    try {
      await logoutUserByAdmin(user.username);
      alert(`Successfully initiated logout for user: ${user.username}`);
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 'An unknown error occurred.';
      setLogoutError(`Logout failed: ${errorMessage}`);
    } finally {
      setIsLoggingOut(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm(`Are you sure you want to PERMANENTLY DELETE user: ${user.username}? This cannot be undone.`)) return;
    setIsDeleting(true);
    setDeleteError('');
    try {
      await deleteUser(user.username);
      onUserDeleted(); // Notify parent to refresh the list
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 'An unknown error occurred.';
      setDeleteError(`Delete failed: ${errorMessage}`);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="bg-qtx-darker p-6 rounded-lg shadow-lg flex flex-col gap-4">
      <div>
        <div className="flex items-center justify-between flex-wrap gap-y-2">
          <div className="flex items-center gap-4">
            <h2 className="text-xl font-semibold text-white">{user.name}</h2>
            {user.is_superuser && <span className="bg-yellow-500 text-black text-xs font-bold px-2 py-1 rounded-full">Superuser</span>}
          </div>
          <div className="flex gap-2">
            <button onClick={handleForceLogout} disabled={isLoggingOut} className="bg-red-600 hover:bg-red-700 disabled:bg-red-900 disabled:cursor-not-allowed text-white font-bold py-2 px-4 rounded transition-colors duration-200">
              {isLoggingOut ? 'Logging out...' : 'Force Logout'}
            </button>
            <button onClick={handleDelete} disabled={isDeleting} className="bg-gray-600 hover:bg-gray-700 disabled:bg-gray-800 disabled:cursor-not-allowed text-white font-bold py-2 px-4 rounded transition-colors duration-200">
              {isDeleting ? 'Deleting...' : 'Delete'}
            </button>
          </div>
        </div>
        <p className="text-qtx-gray mt-2"><span className="font-mono">{user.username}</span> - {user.email}</p>
        {logoutError && <p className="text-red-400 mt-2 text-sm">{logoutError}</p>}
        {deleteError && <p className="text-red-400 mt-2 text-sm">{deleteError}</p>}
      </div>

      <div>
        <h3 className="text-lg font-semibold text-qtx-light-gray border-t border-qtx-dark pt-4">Applications ({user.applications.length})</h3>
        {user.applications.length > 0 ? (
          <div className="mt-2 flex flex-col gap-3">
            {user.applications.map((app) => (
              <div key={app.uuid} className="bg-qtx-dark p-3 rounded-md">
                <p className="font-semibold text-white">{app.name}</p>
                <p className="text-sm text-qtx-gray font-mono">{app.path}</p>
                <div className="flex gap-4 mt-1 text-xs text-qtx-light-gray">
                  <span>Tier: <span className="font-semibold text-white">{app.tier}</span></span>
                  <span>Limit: <span className="font-semibold text-white">{app.limit} / {app.period}s</span></span>
                </div>
              </div>
            ))}
          </div>
        ) : <p className="mt-2 text-qtx-gray italic">No applications linked.</p>}
      </div>
    </div>
  );
};

export default UserCard;